// src/pages/CabinetShared.jsx
// Cabinet de curiosités : lecture d'un cabinet partagé avec moi (lecture seule).
// /cabinets/partages          → liste des invitations reçues
// /cabinets/partages/:shareId → le cabinet (projection servie par la fonction Edge cabinet-share-view)
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { receivedShares, fetchSharedCabinet, themeById } from "../lib/cabinetService";
import { useCabinetText } from "../lib/cabinetI18n";

const sans = "system-ui, sans-serif";

function ReceivedList() {
  const { t, locale } = useCabinetText();
  const [rows, setRows] = useState(null);
  const [err, setErr] = useState(false);
  useEffect(() => {
    receivedShares().then(setRows).catch(() => setErr(true));
  }, []);
  return (
    <div style={{ maxWidth: 640, margin: "40px auto", padding: "0 16px", fontFamily: sans }}>
      <h1 style={{ fontFamily: "Georgia, serif", fontWeight: 400 }}>{t("sharedTitle")}</h1>
      {err && <p>{t("sharedLoadError")}</p>}
      {rows && rows.length === 0 && <p>{t("sharedNone")}</p>}
      <ul style={{ listStyle: "none", padding: 0 }}>
        {(rows || []).map((r) => (
          <li key={r.share_id} style={{ padding: "10px 0", borderBottom: "1px solid #e5e3df" }}>
            <Link to={`/cabinets/partages/${r.share_id}`}>{r.cabinet_title}</Link>
            <span style={{ color: "#8a8378", fontSize: 13 }}>
              {r.owner_first_name ? t("sharedFrom", r.owner_first_name) : ""}{t("sharedUntil", new Date(r.expires_at).toLocaleDateString(locale))}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}

function SharedView({ shareId }) {
  const { t, locale } = useCabinetText();
  const [data, setData] = useState(null);
  const [state, setState] = useState("loading"); // loading | ok | unavailable
  useEffect(() => {
    let alive = true;
    fetchSharedCabinet(shareId)
      .then((d) => { if (alive) { setData(d); setState("ok"); } })
      .catch(() => { if (alive) setState("unavailable"); });
    return () => { alive = false; };
  }, [shareId]);

  if (state === "loading") return <div style={{ padding: 32, fontFamily: sans }}>{t("loading")}</div>;
  if (state === "unavailable") {
    return (
      <div style={{ maxWidth: 560, margin: "48px auto", padding: "0 16px", fontFamily: sans }}>
        <h1 style={{ fontFamily: "Georgia, serif", fontWeight: 400 }}>{t("unavailableTitle")}</h1>
        <p>{t("unavailableBody")}</p>
        <Link to="/cabinets/partages">{t("myInvitations")}</Link>
      </div>
    );
  }
  const theme = themeById(data.theme);
  return (
    <div style={{ minHeight: "100vh", background: theme.wall, color: theme.ink, padding: "32px 16px 64px", fontFamily: sans }}>
      <div style={{ maxWidth: 1100, margin: "0 auto" }}>
        <h1 style={{ fontFamily: "Georgia, serif", fontStyle: "italic", fontWeight: 400, margin: "0 0 4px" }}>{data.title}</h1>
        <p style={{ opacity: 0.7, fontSize: 12, margin: "0 0 24px" }}>
          {t("sharedReadOnly", new Date(data.expires_at).toLocaleDateString(locale))}
        </p>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(240px,1fr))", gap: 28 }}>
          {data.items.map((it) => (
            <figure key={it.position} style={{ margin: 0 }}>
              <div style={{ border: `5px solid ${theme.frame}`, background: "#000", boxShadow: "0 8px 18px rgba(0,0,0,.4)" }}>
                {it.image_url
                  ? <img src={it.image_url} alt={it.title || ""} style={{ width: "100%", display: "block" }} />
                  : <div style={{ height: 200, display: "flex", alignItems: "center", justifyContent: "center", color: "#999", fontSize: 12 }}>{t("noImage")}</div>}
              </div>
              <figcaption style={{ marginTop: 8, fontSize: 13 }}>
                <strong style={{ fontFamily: "Georgia, serif", fontWeight: 400, fontStyle: "italic" }}>{it.title}</strong>
                {it.artist ? <span style={{ opacity: 0.8 }}> — {it.artist}</span> : null}
                {it.year ? <span style={{ opacity: 0.8 }}>, {it.year}</span> : null}
                {it.caption ? <p style={{ margin: "6px 0 0", opacity: 0.9, lineHeight: 1.45 }}>{it.caption}</p> : null}
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </div>
  );
}

export default function CabinetShared() {
  const { shareId } = useParams();
  return shareId ? <SharedView shareId={shareId} /> : <ReceivedList />;
}
